import TaxHeaderSection from "./TaxHeaderSection";
import TaxListComponent from "./TaxListComponent";

const TaxSetupComponent = () => {
  return (
    <>
      <TaxHeaderSection />
      <TaxListComponent />
    </>
  );
};

export default TaxSetupComponent;
